export const Scrollbar = {
  OVERLAY: 'overlay',
  FIXED: 'fixed',
} as const;

export const MOUSE_EVENTS_SUPPORTED = ['mouseup', 'touchend'];

export const KEY = {
  arrowLeft: 'ArrowLeft',
  arrowUp: 'ArrowUp',
  arrowRight: 'ArrowRight',
  arrowDown: 'ArrowDown',
  escape: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  home: 'Home',
  end: 'End',
} as const;

export const ListType = {
  action: 'action',
  select: 'select',
} as const;

export const NOT_HOVERED_INDEX = -1;
export const DIVIDER_OPTION_VALUE = '-';
